import { FC, memo, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import Avatar from '../Avatar/Avatar';
import { centralizadoVerticalmente } from 'styles/Utilitarios';
import Pessoa from 'model/pessoa/Pessoa';
import { PessoasAction } from 'store/Pessoas/Pessoas.action';
import { PessoasSelector } from 'store/Pessoas/Pessoas.selector';
import { NomePessoaConteudo } from '../Pessoa/NomePessoa';
import Tooltip, { TooltipPrimitive } from '@atlaskit/tooltip';


interface AvatarPessoaBuscavelProps {
  idInstitucional: string
  /**
   * Caso o nome não seja exibido e `comLink == true`,
   * será adicionado um title no link com o nome
   */
  exibirNome?: boolean
  ocultarTooltip?: boolean
  'aria-hidden'?: boolean
  /**
   * O componente deve possuir um link para a pessoa?
   */
  comLink?: boolean
}


const InlineDialog = styled(TooltipPrimitive)`
  background: white;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  box-sizing: content-box; /* do not set this to border-box or it will break the overflow handling */
  color: #333;
  max-height: 300px;
  max-width: 300px;
  padding: 8px 12px;
`;


export const AvatarPessoaPesquisavel = memo<AvatarPessoaBuscavelProps>(({idInstitucional, ...props}) => {
  const pessoa = useSelector(PessoasSelector.pessoa(idInstitucional));
  const dispatch = useDispatch();

  useEffect(() => {
    if (pessoa === undefined) {
      dispatch(PessoasAction.carregar(idInstitucional))
    }
  }, [idInstitucional, pessoa, dispatch]);

  return <AvatarPessoa {...props} pessoa={pessoa} />
});


interface AvatarPessoaProps {
  pessoa?: Pessoa
  exibirNome?: boolean
  'aria-hidden'?: boolean
  ocultarTooltip?: boolean
  /**
   * O componente deve possuir um link para a pessoa?
   */
  comLink?: boolean
}

const AvatarPessoa: FC<AvatarPessoaProps> = ({exibirNome, ocultarTooltip, pessoa, comLink, ...props}) => {
  const carregando = pessoa === undefined;
  const conteudo = <Container>
    {ocultarTooltip ? <Avatar {...props} loading={carregando} nome={pessoa?.nome} /> 
     : <Tooltip component={InlineDialog} content={pessoa?.nome}><Avatar {...props} loading={carregando} nome={pessoa?.nome} /></Tooltip>}
    {exibirNome ? <Nome><NomePessoaConteudo pessoa={pessoa} /></Nome> : ''}
  </Container>

  if (comLink && !carregando) {
    return <LinkPessoa pessoa={pessoa!!} isNomeComoTitle={!exibirNome}>
      {conteudo}
    </LinkPessoa>
  } else {
    return conteudo;
  }
}


interface LinkPessoaProps {
  pessoa: Pessoa;
  isNomeComoTitle: boolean
}

const LinkPessoa: FC<LinkPessoaProps> = ({pessoa, isNomeComoTitle, children}) => {
  const linkProps: any = {}

  if (!isNomeComoTitle) {
    linkProps['title'] = pessoa.nome
  }

  return <Link to={`/usuarios/${pessoa.idInstitucional}`} {...linkProps} className="user">
    {children}
  </Link>
}

const Container = styled.span`
  ${centralizadoVerticalmente};
`;

const Nome = styled.span`
  padding-left: 8px;
`;